import React from 'react';
import { useParams } from 'react-router-dom';

import { useQuotes } from 'lib/hooks/queries/billing/useQuotes';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import QuotePreview from './components/QuotePreview';
import { getColDefs } from './lib/columns';
import { DEFAULT_FILTERS } from './lib/defaultFilters';

const Quotes = () => {
  const { id: patientId } = useParams();

  const cols = getColDefs();

  return (
    <AgTablePage
      noTitle
      noNewButton
      name="quotes"
      defaultColumns={cols}
      defaultFilters={DEFAULT_FILTERS}
      useData={useQuotes}
      queryParams={{ patientId }}
      rowStyle={{ cursor: 'pointer' }}
      ModalComponent={QuotePreview}
    />
  );
};

export default Quotes;
